export default "__VITE_ASSET__DjNaxVZj__"